export default "__VITE_ASSET__CLTc3CrL__"